module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/coupon-bc52165f13fdbf643114b37f00ce4306.svg";